// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","484":"1bef058b","551":"f08f88f6","869":"d1c6690c","974":"2be7b50c"}[chunkId] + ".chunk.js";
};